import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import {CustomAttributeListOption} from './model';
import { TranslatedString, translateString } from '../translation-helper';

@Component({
    selector: 'lib-custom-attribute-list-value-picker',
    templateUrl: './custom-attribute-list-value-picker.html',
    styleUrls: ['./custom-attribute-list-value-picker.scss']
})
export class CustomAttributeListValuePickerComponent implements OnInit, OnChanges {
    @Input() options: CustomAttributeListOption[] = [];

    @Input() allowMultiselect = false

    @Input() placeholder: TranslatedString | undefined = undefined;

    @Input() selectedValues?: Array<string | undefined | null> = [];
    @Output() selectedValuesChange = new EventEmitter<string[]>();

    public selectedOptions: Array<CustomAttributeListOption> | CustomAttributeListOption | undefined = undefined;

    ngOnInit() {
        this.updateSelectedOptions();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['selectedValues'] || changes['options'] || changes['allowMultiselect']) {
            this.updateSelectedOptions();
        }
    }

    private updateSelectedOptions() {
        if (!this.options || !this.selectedValues) return;

        const filtered = this.options.filter(o => this.selectedValues?.includes(o.value));

        this.selectedOptions = this.allowMultiselect ? filtered : filtered[0];
    }

    onChange(selected: CustomAttributeListOption | CustomAttributeListOption[]) {
        if (!selected) {
            this.selectedOptions = undefined;
            this.selectedValues = [];
            this.selectedValuesChange.emit([]);
            return;
        }

        if (Array.isArray(selected)) {
            this.selectedValuesChange.emit(selected.map(o => o.value));
        } else {
            this.selectedValuesChange.emit([selected.value]);
        }
    }

    public getPlaceholder(): string {
        const placeholder = this.placeholder ? translateString(this.placeholder) : undefined;
        return placeholder ? placeholder : this.allowMultiselect ? 'Select values' : 'Select value';
    }

    public hasAtLeastOneOptionIcon(): boolean {
        return this.options.some(option => option.icon);
    }
}
